
import { Button, List, ListItem, ListItemIcon, ListItemText, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Table, Checkbox, FormControlLabel, Grid, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Typography, Box } from '@material-ui/core';
import { Menu, MenuItem } from '@material-ui/core';
import { Edit, Receipt, Delete, Add, FindInPage } from '@material-ui/icons'
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import { ExamPaperSitting } from '../../../interfaces/teacher/ExamPaperSitting';
import DataTable from 'react-data-table-component';
import request from '../../../api';
import StudentTimer from '../../student/exams/StudentTimer';

interface Props {
}

interface State {
  data:ExamPaperSitting[]|null
  totalRows:number
  rowsPerPage:number
  page:number
  sortColumn:string
  sortOrder:'asc'|'desc'
  onlyFinished: boolean
  allocateDialogOpen: boolean
  reopenDialogOpen: boolean
  selectedSitting: ExamPaperSitting | null
  extraTimeMinutes: string
  reopenReasonChoice: string
  reopenReasonOther: string
  reopenExtraTime: string
  isBulkAllocate: boolean
  isBulkReopen: boolean
  selectedIds: string[]
  bulkMenuAnchor: any
  timerTick: number
}

export default class TeacherSittingList extends React.Component<Props, State> {

  constructor(props:Props) {

    super(props)

    this.state = {
      data:[],
      totalRows:0,
      rowsPerPage:10,
      page:1,
      sortColumn:'finished',
      sortOrder:'desc',
      onlyFinished: false,
      allocateDialogOpen: false,
      reopenDialogOpen: false,
      selectedSitting: null,
      extraTimeMinutes: '',
      reopenReasonChoice: '',
      reopenReasonOther: '',
      reopenExtraTime: '',
      isBulkAllocate: false,
      isBulkReopen: false,
      selectedIds: [],
      bulkMenuAnchor: null,
      timerTick: 0

    }
  }

  private formatDuration(totalSeconds: number): string {
    if (!Number.isFinite(totalSeconds) || totalSeconds < 0) {
      return '-'
    }
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = Math.floor(totalSeconds % 60)
    if (minutes === 0) {
      return `${seconds}s`
    }
    return `${minutes}m ${seconds.toString().padStart(2, '0')}s`
  }

  private getEffectiveDeadlineMs(sitting: ExamPaperSitting): number | null {
    if (!sitting.deadline) return null
    const base = new Date(sitting.deadline).getTime()
    if (!Number.isFinite(base)) return null
    const extraMs = (sitting.extraTimeAllowance || 0) * 60 * 1000
    return base + extraMs
  }

   columns: any[] = [
        {
            name: 'Username',
            selector: 'studentUsername',
            sortable: false,
            wrap: true
        },
        {
            name: 'Name',
            selector: 'studentName',
            sortable: false,
            wrap: true
        },
        {
            name: 'Paper',
            selector: 'paperTitle',
            sortable: false,
            wrap: true,
        },
        {
          name: 'Started',
          selector: 'started',
          sortable: true,
          wrap: true,
          cell: (sitting: ExamPaperSitting) => new Date(sitting.started).toLocaleDateString()
        },
        {
          name: 'Deadline',
          selector: 'deadline',
          sortable: true,
          wrap: true,
          cell: (sitting: ExamPaperSitting) =>
            (() => {
              const ms = this.getEffectiveDeadlineMs(sitting)
              return ms ? new Date(ms).toLocaleTimeString() : '-'
            })()
        },
        {
          name: 'Finished',
          selector: 'finished',
          sortable: true,
          wrap: true,
          cell: (sitting: ExamPaperSitting) => sitting.finished ? new Date(sitting.finished).toLocaleTimeString() : ''
        },
        {
          name: 'Time spent',
          sortable: false,
          wrap: true,
          cell: (sitting: ExamPaperSitting) => {
            if (typeof sitting.totalTimeSpentSeconds === 'number' && sitting.totalTimeSpentSeconds > 0) {
              return this.formatDuration(sitting.totalTimeSpentSeconds)
            }

            return sitting.deadline
              ? (sitting.finished
                  ? <StudentTimer started={sitting.started} deadline={sitting.deadline} extraTimeAllowance={sitting.extraTimeAllowance} finished={sitting.finished}/>
                  : <StudentTimer started={sitting.started} deadline={sitting.deadline} extraTimeAllowance={sitting.extraTimeAllowance}/>
                )
              : '-'
          }
        },
        {
          name: 'Extra Time Reason',
          sortable: false,
          wrap: true,
          cell: (sitting: ExamPaperSitting) => sitting.extraTimeReason || ''
        },
        {
          name: 'Reopened',
          sortable: false,
          wrap: true,
          cell: (sitting: ExamPaperSitting) => sitting.reopenedAt ?
            new Date(sitting.reopenedAt).toLocaleDateString() : ''
        },
        {
          name: 'Auto-Submitted',
          sortable: false,
          wrap: true,
          cell: (sitting: ExamPaperSitting) => sitting.autoSubmitted ? 'Yes' : 'No'
        },
        {
          name: 'Actions',
          sortable: false,
          minWidth: '200px',
          cell: (sitting: ExamPaperSitting) => (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px',
              alignItems: 'stretch'
            }}>
              {/* Initial in-progress sitting (never reopened): allow allocate extra time */}
              {!sitting.finished && !sitting.reopenedAt && (
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  fullWidth
                  onClick={() => this.allocateExtraTime(sitting)}
                >
                  Allocate Extra Time
                </Button>
              )}
              {/* Finished / auto-submitted sitting: allow reopen */}
              {sitting.finished && (
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  fullWidth
                  onClick={() => this.reopenSitting(sitting)}
                >
                  Reopen Paper
                </Button>
              )}
              {/* Any live sitting (initial or reopened): allow end paper */}
              {!sitting.finished && (
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  fullWidth
                  onClick={() => this.endExam(sitting.id)}
                >
                  End Paper
                </Button>
              )}
            </div>
          )
      }
    ]

  allocateExtraTime = (sitting: ExamPaperSitting) => {
    this.setState({
      allocateDialogOpen: true,
      selectedSitting: sitting,
      isBulkAllocate: false,
      extraTimeMinutes: ''
    })
  }

  reopenSitting = (sitting: ExamPaperSitting) => {
    this.setState({
      reopenDialogOpen: true,
      selectedSitting: sitting,
      isBulkReopen: false,
      reopenReasonChoice: '',
      reopenReasonOther: '',
      reopenExtraTime: ''
    })
  }

  handleAllocateSubmit = async () => {
    const { selectedSitting, extraTimeMinutes, isBulkAllocate, selectedIds } = this.state
    if (!extraTimeMinutes) return

    const payload = {
      extraTimeMinutes: parseInt(extraTimeMinutes, 10)
    }

    try {
      if (isBulkAllocate) {
        if (selectedIds.length === 0) return
        await request(`/api/teacher/sittings/bulkAllocateExtraTime`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...payload, sittingIds: selectedIds })
        })
      } else {
        if (!selectedSitting) return
        await request(`/api/teacher/sittings/${selectedSitting.id}/allocateExtraTime`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
      }
      this.setState({ allocateDialogOpen: false, selectedSitting: null })
      this.reload()
    } catch (error) {
      console.error('Failed to allocate extra time:', error)
    }
  }

  handleReopenSubmit = async () => {
    const { selectedSitting, reopenReasonChoice, reopenReasonOther, reopenExtraTime, isBulkReopen, selectedIds } = this.state

    if (!reopenReasonChoice) return
    if (reopenReasonChoice === 'other' && !reopenReasonOther.trim()) return
    if (!reopenExtraTime) return

    const selectedLabelMap: { [key: string]: string } = {
      ET: 'ET',
      Interruption: 'Interruption',
      'Internet access': 'Internet access',
      other: reopenReasonOther.trim()
    }

    const finalReason = selectedLabelMap[reopenReasonChoice]

    const payload = {
      reason: finalReason,
      additionalTime: parseInt(reopenExtraTime, 10)
    }

    try {
      if (isBulkReopen) {
        if (selectedIds.length === 0) return
        await request(`/api/teacher/sittings/bulkReopen`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...payload, sittingIds: selectedIds })
        })
      } else {
        if (!selectedSitting) return
        await request(`/api/teacher/sittings/${selectedSitting.id}/reopen`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
      }
      this.setState({ reopenDialogOpen: false, selectedSitting: null })
      this.reload()
    } catch (error) {
      console.error('Failed to reopen sitting:', error)
    }
  }

  render() {

    let { data, totalRows, rowsPerPage, page } = this.state

    if(data === null) {
        return <div>Loading...</div>
    }

    let conditionalRowStyles = [
      // Reopened but not yet started again: show as blue
      {
        when: (row: ExamPaperSitting) =>
          this.isPendingReopen(row.deadline, row.finished, row.reopenedAt),
        style: {
          backgroundColor: '#1976d2',
          color: 'white',
          '&:hover': {
            cursor: 'cell',
            backgroundColor: '#115293',
          },
        },
      },
      // Past deadline (overtime) – shown as purple
      {
        when: (row: ExamPaperSitting) => this.isPastDeadline(row),
        style: {
          backgroundColor: '#ba68c8',
          color: 'white',
          '&:hover': {
            cursor: 'cell',
            backgroundColor: '#9c27b0',
          },
        },
      },
      // Live sittings (initial or reopened and in progress, not overtime/pending) – shown as green
      {
        when: (row: ExamPaperSitting) => this.isLive(row),
        style: {
          backgroundColor: '#4caf50',
          color: 'white',
          '&:hover': {
            cursor: 'cell',
            backgroundColor: '#388e3c',
          },
        },
      },
    ];

    const customStyles = {
      headCells: {
        style: {
          paddingLeft: '12px',
          paddingRight: '12px',
          fontWeight: '600',
          fontSize: '14px',
        },
      },
      cells: {
        style: {
          paddingLeft: '12px',
          paddingRight: '12px',
          paddingTop: '8px',
          paddingBottom: '8px',
        },
      },
      rows: {
        style: {
          minHeight: '48px',
        },
      },
    };

    return (
        <Fragment>
            <Box 
              style={{ 
                backgroundColor: '#e3f2fd', 
                padding: '12px', 
                borderRadius: '4px', 
                marginBottom: '16px',
                border: '1px solid #90caf9'
              }}
            >
              <Typography variant="body2" style={{ color: '#1565c0', fontWeight: 500 }}>
                ℹ️ Data refreshes automatically every 10 seconds. You can also refresh the page for up-to-date data.
              </Typography>
            </Box>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                  <Button variant="outlined" color="secondary" onClick={() => this.endExams()}>End All Open Papers</Button>
              </Grid>
              <Grid item xs={3}>
                  <FormControlLabel
                             control={
                                 <Checkbox checked={this.state.onlyFinished} onClick={() => this.handleToggleOnlyFinished()} />}
                             label="View only unfinished papers"
                  />
              </Grid>
              <Grid item xs={3}>
                  <Button
                    variant="outlined"
                    onClick={(e) => this.setState({ bulkMenuAnchor: e.currentTarget })}
                    disabled={this.state.selectedIds.length === 0}
                  >
                    Bulk actions
                  </Button>
                  <Menu
                    anchorEl={this.state.bulkMenuAnchor}
                    keepMounted
                    open={Boolean(this.state.bulkMenuAnchor)}
                    onClose={() => this.setState({ bulkMenuAnchor: null })}
                  >
                    <MenuItem
                      onClick={() => {
                        this.setState({
                          bulkMenuAnchor: null,
                          allocateDialogOpen: true,
                          isBulkAllocate: true,
                          extraTimeMinutes: ''
                        })
                      }}
                      disabled={
                        this.getSelectedRows().length === 0 ||
                        !this.getSelectedRows().every(r => !r.finished && !r.reopenedAt)
                      }
                    >
                      Allocate Extra Time to selected
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.setState({
                          bulkMenuAnchor: null,
                          reopenDialogOpen: true,
                          isBulkReopen: true,
                          reopenReasonChoice: '',
                          reopenReasonOther: '',
                          reopenExtraTime: ''
                        })
                      }}
                      disabled={
                        this.getSelectedRows().length === 0 ||
                        !this.getSelectedRows().every(r => !!r.finished)
                      }
                    >
                      Reopen selected papers
                    </MenuItem>
                  </Menu>
              </Grid>
            </Grid>
                  <br />
                  <br />
            <DataTable
                columns={this.columns}
                data={data}
                selectableRows
                onSelectedRowsChange={(state: { selectedRows: ExamPaperSitting[] }) =>
                  this.setState({ selectedIds: state.selectedRows.map(r => r.id) })
                }
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationRowsPerPageOptions = {[10,25,50,100,500]}
                sortServer
                onSort={this.handleSort}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                onChangePage={this.handleChangePage}
                noHeader
                conditionalRowStyles={conditionalRowStyles}
                customStyles={customStyles}
            />

            <Dialog open={this.state.allocateDialogOpen} onClose={() => this.setState({ allocateDialogOpen: false })}>
                <DialogTitle>Allocate Extra Time</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" style={{ marginBottom: 16 }}>
                        {this.state.isBulkAllocate
                          ? `Allocate additional time for ${this.state.selectedIds.length} sittings`
                          : `Allocate additional time for student: ${this.state.selectedSitting?.studentName}`
                        }
                    </Typography>
                    <TextField
                        label="Extra Time (minutes)"
                        type="number"
                        fullWidth
                        value={this.state.extraTimeMinutes}
                        onChange={(e) => this.setState({ extraTimeMinutes: e.target.value })}
                        style={{ marginBottom: 16 }}
                    />
                    <Typography variant="caption" color="textSecondary">
                        Reason: ET
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ allocateDialogOpen: false })}>Cancel</Button>
                    <Button
                        onClick={this.handleAllocateSubmit}
                        color="primary"
                        disabled={!this.state.extraTimeMinutes}
                    >
                        Allocate Time
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={this.state.reopenDialogOpen} onClose={() => this.setState({ reopenDialogOpen: false })}>
                <DialogTitle>Reopen Paper</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" style={{ marginBottom: 16 }}>
                        {this.state.isBulkReopen
                          ? `Reopen ${this.state.selectedIds.length} sittings`
                          : `Reopen paper for student: ${this.state.selectedSitting?.studentName}`
                        }
                    </Typography>
                    <TextField
                        select
                        SelectProps={{ native: true }}
                        label="Reason for reopening"
                        fullWidth
                        value={this.state.reopenReasonChoice}
                        onChange={(e) => this.setState({ reopenReasonChoice: e.target.value as string })}
                        style={{ marginBottom: 16 }}
                    >
                        <option value=""></option>
                        <option value="ET">ET</option>
                        <option value="Interruption">Interruption</option>
                        <option value="Internet access">Internet access</option>
                        <option value="other">Other</option>
                    </TextField>
                    {this.state.reopenReasonChoice === 'other' && (
                        <TextField
                            label="Custom reason"
                            multiline
                            rows={3}
                            fullWidth
                            value={this.state.reopenReasonOther}
                            onChange={(e) => this.setState({ reopenReasonOther: e.target.value })}
                            placeholder="Enter reason for reopening"
                            style={{ marginBottom: 16 }}
                        />
                    )}
                    <TextField
                        label="Additional time (minutes)"
                        type="number"
                        fullWidth
                        value={this.state.reopenExtraTime}
                        onChange={(e) => this.setState({ reopenExtraTime: e.target.value })}
                        placeholder="Extra time to add for this attempt"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ reopenDialogOpen: false })}>Cancel</Button>
                    <Button
                        onClick={this.handleReopenSubmit}
                        color="primary"
                        disabled={
                          !this.state.reopenReasonChoice ||
                          (this.state.reopenReasonChoice === 'other' && !this.state.reopenReasonOther.trim()) ||
                          !this.state.reopenExtraTime
                        }
                    >
                        Reopen Paper
                    </Button>
                </DialogActions>
            </Dialog>
      </Fragment>
    )
  }

  interval:any
  timerInterval:any
  componentDidMount() {
      this.reload()
      this.interval = setInterval(() => this.reload(), 1000*10)
      this.timerInterval = setInterval(() => {
          this.setState({ timerTick: Date.now() })
      }, 1000)
  }

  componentWillUnmount(){
    clearInterval(this.interval)
    clearInterval(this.timerInterval)
  }

  private async reload() {

    let { page, rowsPerPage, sortColumn, sortOrder, onlyFinished } = this.state

    let { sittings, total } = await (
        await request(`/api/teacher/sittings?offset=${(page - 1) * rowsPerPage}&limit=${rowsPerPage}&sortBy=${sortColumn}&order=${sortOrder}&onlyFinished=${onlyFinished}`)
    ).json()

    this.setState(prevState => ({ ...prevState, data: sittings, totalRows: total }))
  }

  private getSelectedRows(): ExamPaperSitting[] {
    const { data, selectedIds } = this.state
    if (!data || selectedIds.length === 0) return []
    return data.filter(row => selectedIds.includes(row.id))
  }

  handleChangeRowsPerPage = async (rowsPerPage:number) => {
      await this.setState(prevState => ({ ...prevState, rowsPerPage }))
      this.reload()
  }

  handleChangePage = async (page:number) => {
      await this.setState(prevState => ({ ...prevState, page }))
      this.reload()
  }

  handleSort = async (column:any, sortDirection:any) => {
      await this.setState(prevState => ({ ...prevState, sortColumn: column.selector, sortOrder: sortDirection }))
      this.reload()
  }

  handleToggleOnlyFinished = async () => {
    await this.setState(prevState => ({ ...prevState, onlyFinished: !this.state.onlyFinished}))
    this.reload()
}

  async endExam(sittingId:string) {

      await request(`/api/teacher/sittings/${sittingId}/close`,{
        method: 'POST'
      })

      this.reload()
  }

  async endExams() {

    await request(`/api/teacher/sittings/closeAll`,{
      method: 'POST'
    })

    this.reload()
  }

  async unEndExam(sittingId:string) {

    await request(`/api/teacher/sittings/${sittingId}/unClose`,{
      method: 'POST'
    })

    await this.reload()
}

isLive(row: ExamPaperSitting) {
  if (row.finished) return false
  if (!row.deadline) return false
  if (this.isPastDeadline(row)) return false
  if (this.isPendingReopen(row.deadline, row.finished, row.reopenedAt)) return false
  return true
}

isPastDeadline(row: ExamPaperSitting) {
  if (row.finished) return false
  const effectiveMs = this.getEffectiveDeadlineMs(row)
  if (!effectiveMs) return false
  return Date.now() > effectiveMs
}

  isPendingReopen(deadline: string | null, finished: string, reopenedAt?: string) {
    // Reopened, not finished, and deadline not yet started for this attempt
    return !!reopenedAt && !finished && !deadline
  }

}